import React from "react";
import { Loader2, Check, X } from "lucide-react";

// Tiny shared form-field primitives extracted from QuoteView.jsx
// (iter-102 refactor). PlainInput is the borderless line-edit input
// used inside the printable quote card; SaveStatusPill is the
// "Saving… / Saved · 3 sec ago / Failed — retry" auto-save indicator;
// MetaRow is the right-aligned label/value row in the quote header
// meta box.

export function PlainInput({
    value,
    onChange,
    placeholder,
    testid,
    bold = false,
    light = false,
    larger = false,
}) {
    return (
        <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            data-testid={testid}
            className={`w-full bg-transparent outline-none border-b border-transparent hover:border-slate-300 focus:border-[#1e6fd9] py-0 leading-snug ${
                bold ? "font-bold" : ""
            } ${larger ? "text-[15px] mb-0.5" : light ? "text-sm" : "text-[13px]"} text-slate-900 placeholder:text-slate-400`}
        />
    );
}

export function SaveStatusPill({ status, onRetry, visible }) {
    if (!visible) return null;
    if (status.state === "idle") return null;
    if (status.state === "saving") {
        return (
            <span
                className="inline-flex items-center gap-1 px-2 py-1 text-[10px] uppercase tracking-wider font-bold rounded-sm bg-[#0A1128] border border-[#2A3655] text-slate-300"
                data-testid="quote-save-status-saving"
            >
                <Loader2 className="w-3 h-3 animate-spin text-[#00A3FF]" />
                Saving…
            </span>
        );
    }
    if (status.state === "saved") {
        const seconds = Math.max(0, Math.floor((Date.now() - status.at) / 1000));
        const label =
            seconds < 5
                ? "just now"
                : seconds < 60
                    ? `${seconds} sec ago`
                    : seconds < 3600
                        ? `${Math.floor(seconds / 60)} min ago`
                        : "saved";
        return (
            <span
                className="inline-flex items-center gap-1 px-2 py-1 text-[10px] uppercase tracking-wider font-bold rounded-sm bg-[#00C853]/10 border border-[#00C853]/40 text-[#00E676]"
                data-testid="quote-save-status-saved"
            >
                <Check className="w-3 h-3" />
                Saved · {label}
            </span>
        );
    }
    // failed
    return (
        <button
            type="button"
            onClick={onRetry}
            data-testid="quote-save-status-failed"
            title={status.error || "Save failed — tap to retry"}
            className="inline-flex items-center gap-1 px-2 py-1 text-[10px] uppercase tracking-wider font-bold rounded-sm bg-red-500/15 hover:bg-red-500/25 border border-red-500/40 text-red-300 hover:text-red-200"
        >
            <X className="w-3 h-3" />
            Failed — retry
        </button>
    );
}

export function MetaRow({ label, children }) {
    return (
        <div className="row flex justify-end items-center gap-2">
            <span className="lbl font-bold uppercase tracking-wide text-xs">
                {label}
            </span>
            {children}
        </div>
    );
}
